import Vue from 'vue'
import App from './App.vue'
import router from './components/router'

Vue.config.productionTip = false
Vue.prototype.$APIlink=  'https://skillcourts-api.skillgam.es/api/'
// Vue.prototype.$APIlink=  'http://127.0.0.1:8000/api/'

new Vue({ el: '#app', router, components:{App}, render: h => h(App) })